import React from "react"

const RequiredStar = () => {
    return (
        <font color="red">*&nbsp;</font>
    )
}

export default RequiredStar